import { Grid, InputLabel, Select, Button, FormControl, Switch, MenuItem, TextField } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";

import { CustomField } from '../../inputs/CustomField';

export const FormInstitutions = ({ onClose }) => {

    const {isSubmitting,values } = useFormikContext();

    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12} md={6}>
                        <CustomField name="nombre" label="Nombre de la institución" values={values?.nombre || ""} as={TextField} fullWidth />
                </Grid>

                <Grid item xs={12} md={6}>
                        <CustomField name="siglas" label="Siglas de la institución" values={values?.siglas || ""} as={TextField} fullWidth />
                </Grid>

                <Grid item xs={12} md={6}>
                        <CustomField name="direccion" multiline rows={4} label="Dirección" values={values?.direccion || ""} as={TextField}  fullWidth/>
                </Grid>

                <Grid item xs={12} md={6}>
                        <CustomField name="telefono" label="Teléfono" values={values?.telefono || ""} as={TextField}  fullWidth/>
                </Grid>

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>

                <Button
                    variant="outlined"
                    onClick={() => onClose()}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>

            </Grid>

        </FormikForm>
    );
}

export default FormInstitutions;